var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, put, takeLatest, } from "@redux-saga/core/effects";
import axios from 'axios';
import { select, take, } from "redux-saga/effects";
import safeSaga from "./utils";
import { parseSchema } from "../../utils/schema/SchemaParser";
import { FETCH_AND_PARSE_SCHEMA, FETCH_SCHEMA, PARSE_AND_SET_SCHEMA, SET_SCHEMA, } from "../actions/availableActions";
import { fetchSchema, parseAndSetSchema, setParsedSchema, setSchema, } from "../actions/schema";
import { getDefaultSchemaReference } from "../../utils/schema/schemaUtils";
function parseAndSetSchemaHandler(_a) {
    var schemaId, reference, parsingReference, schemaElements, schema, schemaKey;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                schemaId = payload.schemaId, reference = payload.reference;
                parsingReference = reference;
                return [4, select(function (_a) {
                        var schema = _a.schema;
                        return schema.schemas[schemaId];
                    })];
            case 1:
                schemaElements = (_b.sent());
                if (!schemaElements[reference]) {
                    parsingReference = getDefaultSchemaReference(schemaElements);
                }
                schema = parseSchema(schemaElements, parsingReference);
                schemaKey = schemaId + "_" + reference;
                return [4, put(setParsedSchema({ schemaKey: schemaKey, schema: schema }))];
            case 2:
                _b.sent();
                return [2];
        }
    });
}
function fetchSchemaHandler(_a) {
    var data;
    var _b = _a.payload, url = _b.url, schemaId = _b.schemaId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, axios.get(url + "/schema/" + schemaId)];
            case 1:
                data = (_c.sent()).data;
                return [4, put(setSchema({ schemaId: schemaId, schema: data.elements }))];
            case 2:
                _c.sent();
                return [2];
        }
    });
}
function fetchAndParseSchemaHandler(_a) {
    var _b = _a.payload, url = _b.url, schemaId = _b.schemaId, reference = _b.reference;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, put(fetchSchema({ url: url, schemaId: schemaId }))];
            case 1:
                _c.sent();
                return [4, take(SET_SCHEMA)];
            case 2:
                _c.sent();
                return [4, put(parseAndSetSchema({ schemaId: schemaId, reference: reference }))];
            case 3:
                _c.sent();
                return [2];
        }
    });
}
export default function schemaSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, all([
                    takeLatest(FETCH_SCHEMA, safeSaga(fetchSchemaHandler)),
                    takeLatest(FETCH_AND_PARSE_SCHEMA, safeSaga(fetchAndParseSchemaHandler)),
                    takeLatest(PARSE_AND_SET_SCHEMA, safeSaga(parseAndSetSchemaHandler)),
                ])];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
